import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { IconSvg } from 'src/assets';
import { SeatProps } from 'src/common/api/response';
import { Container, RegularText, Row } from 'src/components';
import { SEAT_STATUS } from 'src/constants/constants';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

interface Props {
  // color?: string;
  label: string;
}

interface SeatItemProps {
  onPress: (seat: SeatProps) => any;
  seat: SeatProps;
  isSelected: boolean;
  disabled?: boolean;
}

export const SeatIndicator = ({ label }: Props) => {
  const getFill = () => {
    if (label === SEAT_STATUS.BOOKED) return AppColors.seatAvailability.booked;
    if (label === SEAT_STATUS.BUSY) return AppColors.seatAvailability.busy;
    if (label === SEAT_STATUS.SELECTED) return AppColors.seatAvailability.selected;
    return AppColors.seatAvailability.available;
  };

  return (
    <Container align="center">
      <IconSvg.SelectSeatSmall fill={getFill()} />
      <Container paddingTop={metrics.small}>
        <RegularText color={AppColors.black} textLang={label} />
      </Container>
    </Container>
  );
};

export const SeatItem: React.FC<SeatItemProps> = ({ disabled, onPress, seat, isSelected }) => {
  const getFill = () => {
    if (isSelected) return AppColors.seatAvailability.selected;
    if (seat.status === SEAT_STATUS.BOOKED) return AppColors.seatAvailability.booked;
    if (seat.status === SEAT_STATUS.BUSY) return AppColors.seatAvailability.busy;
    return AppColors.seatAvailability.available;
  };

  return (
    <Container>
      <Container width="100%" height={pixelScaler(20)}>
        {seat.watching && seat.watching > 0 ? (
          <Row style={{ justifyContent: 'center', alignItems: 'center' }} height="100%">
            <RegularText fontSize="medium" color={AppColors.orange} fontWeight="bold">
              {seat.watching}
            </RegularText>
            <IconSvg.Eye style={{ marginTop: 2 }} />
          </Row>
        ) : (
          <View />
        )}
      </Container>
      <TouchableOpacity
        style={{ width: '100%' }}
        disabled={disabled || seat.status === SEAT_STATUS.BOOKED || seat.status === SEAT_STATUS.BUSY}
        activeOpacity={0.8}
        onPress={() => onPress(seat)}>
        <Container width="100%" align="center">
          <IconSvg.SelectSeat fill={getFill()} />
          <Container style={{ position: 'absolute', marginBottom: metrics.small }}>
            <RegularText
              fontWeight="bold"
              color={isSelected || seat.status === SEAT_STATUS.BOOKED ? 'white' : AppColors.black}
              fontSize="medium"
              textLang={seat.label}
            />
          </Container>
        </Container>
      </TouchableOpacity>
    </Container>
  );
};

// export const BackSeatItem: React.FC<SeatItemProps> = ({ onPress, seat, isSelected }) => {
//   const getFill = () => {
//     if (isSelected) return AppColors.seatAvailability.selected;
//     if (seat.status === SEAT_STATUS.BOOKED) return AppColors.seatAvailability.booked;
//     return AppColors.seatAvailability.available;
//   };

//   return (
//     <Container width={pixelScaler(45)}>
//       <Container width="100%" height={pixelScaler(20)}>
//         {seat.watching && (
//           <Row style={{ justifyContent: 'space-evenly' }} middle height="100%">
//             <RegularText fontSize="medium" color={AppColors.orange} fontWeight="bold">
//               {seat.watching}
//             </RegularText>
//             <IconSvg.Eye style={{ marginTop: 2 }} />
//           </Row>
//         )}
//       </Container>
//       <TouchableOpacity
//         style={{ marginLeft: -pixelScaler(2) }}
//         disabled={seat.status === SEAT_STATUS.BOOKED}
//         activeOpacity={0.8}
//         onPress={onPress}>
//         <Container width="100%" align="center">
//           <IconSvg.SelectSeat fill={getFill()} />
//           <Container style={{ position: 'absolute', marginBottom: metrics.small }}>
//             <RegularText
//               fontWeight="bold"
//               color={isSelected || seat.status === SEAT_STATUS.BOOKED ? 'white' : AppColors.black}
//               fontSize="medium"
//               textLang={seat.label}
//             />
//           </Container>
//         </Container>
//       </TouchableOpacity>
//     </Container>
//   );
// };
